(function(){
  const API='https://saudepro-rastreio.vercel.app';
  const VID_KEY='sp_vid';
  let vid=localStorage.getItem(VID_KEY);
  if(!vid){ vid='v_'+Math.random().toString(36).slice(2,10)+Date.now().toString(36); localStorage.setItem(VID_KEY,vid); }
  function getSource(){
    const r=document.referrer||''; const u=location.href;
    if(u.includes('fb')||r.includes('facebook')) return 'facebook';
    if(r.includes('instagram')) return 'instagram';
    if(r.includes('google')) return 'google';
    if(r.includes('tiktok')) return 'tiktok';
    return 'direct';
  }
  function getMeta(){
    const title=document.title||location.pathname;
    return {page:location.pathname+location.search, label:title.slice(0,200), source:getSource()};
  }
  async function sendTrack(extra={}){
    try{
      const m=getMeta();
      const params=new URLSearchParams({vid:vid,page:m.page,label:m.label,source:m.source,country:'AO',region:'Luanda',...extra});
      await fetch(`${API}/api/hit?${params.toString()}`,{method:'GET',mode:'cors',cache:'no-store'});
    }catch(e){ console.log('track err',e); }
  }
  // Pageview inicial
  sendTrack();
  // Heartbeat 20s
  setInterval(()=>sendTrack(),20000);
  // Cliques
  document.addEventListener('click',function(e){
    const a=e.target.closest('a');
    if(!a) return;
    const href=(a.href||'').toLowerCase();
    const text=(a.textContent||a.innerText||'').trim().slice(0,100);
    if(href.includes('wa.me')||href.includes('whatsapp')) sendTrack({click:'whatsapp',val:'WhatsApp'});
    else if(href.includes('.pdf')) sendTrack({click:'pdf',val:text||'PDF'});
    else if(href.includes('/products/')||href.includes('/collections/')){
      const label=text||a.getAttribute('title')||href;
      sendTrack({click:'product',val:label});
    } else if(href.startsWith('http')){
      sendTrack({click:'link',val:text||href});
    }
  });
  window.SaudeProTrack={vid:vid,send:sendTrack};
})();